<div class="rounded-2xl bg-white p-6 filters-shadow">
  <div class="mb-5 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">


    <div class="sm:col-span-2 lg:col-span-2">
      <app-pharmacy-auto-complete
        variant="default"
        [label]="pharmacyFilterLabel"
        [placeholder]="pharmacyPlaceholder"
        [noResultsText]="noPharmaciesFoundText"
        [clear]="clearPharmacySignal()"
        (itemSelected)="onPharmacySelected($event)" />
    </div>

    <div>
      <app-filter-item-search
        [label]="orderIdFilter"
        [placeholder]="orderIdPlaceholder"
        [searchTerm]="orderSearch()"
        (searchTermChange)="onOrderIdChange($event)" />
      @if (orderIdError()) {
        <p class="mt-1 text-xs text-red-500">{{ orderIdError() }}</p>
      }
    </div>


    <app-filter-multi-select
      [label]="statusFilter"
      [items]="statusOptions"
      [placeholder]="allStatuses"
      [(selectedIds)]="selectedStatuses"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="toggleStatusDropdown()"
      (selectionChange)="onStatusChange($event)" />
  </div>


  <div class="mb-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
  
    <div>
      <app-filter-date-component
        [label]="createdDateFromLabel"
        [value]="createdFrom()"
        (valueChange)="onFromDateChange($event)" />

      @if (fromDateError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ fromDateError() }}
        </p>
      }
    </div>

   
    <div>
      <app-filter-date-component
        [label]="createdDateToLabel"
        [value]="createdTo()"
        (valueChange)="onToDateChange($event)" />

      @if (toDateError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ toDateError() }}
        </p>
      }
    </div>

  
    <app-filter-item-search
      [label]="createdByFilter"
      [placeholder]="createdByPlaceholder"
      [(searchTerm)]="createdBySearch" />
  </div>

  <hr class="mb-5 border-gray-200" />


  <div class="flex flex-wrap items-center justify-between gap-4">
    <app-filter-sorting-component
      [(orderBy)]="orderBy"
      [orderDir]="orderDir()"
      [sortOptions]="sortOptions"
      (toggleOrder)="toggleSortOrder()" />

    <div class="flex gap-3">
      <app-submit-button type="secondary" (click)="resetFilters()">
        <span i18n="@@returnsListReset">Clear</span>
      </app-submit-button>

      <app-submit-button type="primary" (click)="applyFilters()">
        <span i18n="@@returnsListApply">Apply</span>
      </app-submit-button>
    </div>
  </div>
</div>

<div class="mt-6  p-6 ">
<app-cards-list
  [headerItems]="returnHeaderItems"
  [rows]="returnRows"
  [currentActions]="actions()"
  [isFiltersApplied]="isFiltersApplied()"
  (actionTrigger)="handleAction($event)">
</app-cards-list>

</div>





<div class="mt-3 rounded-2xl bg-white p-2 shadow-md">
  <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="getPageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="onPreviousPage()"
      (nextPage)="onNextPage()"
      (goToPage)="onGoToPage($event)"
      (changePageNumber)="onChangePageNumber($event)"
      (pageSizeChange)="onPageSizeChange()" />
  </div>